import React, { useRef, useEffect } from "react";
import { Text, View, Animated } from "react-native";
import Svg, { Circle, Defs, G, LinearGradient, Stop } from "react-native-svg";
import metrics from "../../constants/metrics";

const AnimatedCircle = Animated.createAnimatedComponent(Circle);

const Stat = (props) => {
  const { percentage, title, subTitle, disabled = false } = props;
  const width = (metrics.screenWidth - 30 - 30) / 2;

  const pieWidth = width - 30;
  const circumference = 2 * Math.PI * (pieWidth / 2);
  const strokeWidth = 10;
  const radius = pieWidth / 2;
  const halfCircle = radius + strokeWidth;

  const circleRef = useRef();
  const animatedValue = useRef(new Animated.Value(0)).current;

  const animation = (toValue) =>
    Animated.timing(animatedValue, {
      toValue,
      duration: 800,
      delay: 0,
      useNativeDriver: true,
    }).start(() => {
      animatedValue.removeAllListeners();
    });

  useEffect(() => {
    animation(percentage);
    animatedValue.addListener(({ value }) => {
      if (circleRef?.current) {
        const maxPerc = Math.min((100 * value) / 100, 100);
        const strokeDashoffset =
          circumference - (circumference * maxPerc) / 100;
        circleRef.current.setNativeProps({
          strokeDashoffset,
        });
      }
    });
    () => animatedValue.removeAllListeners();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return title && subTitle ? (
    <>
      <View
        style={{
          padding: 15,
          borderRadius: 10,
          backgroundColor: "white",
          elevation: 2,
          marginVertical: 15,
          overflow: "visible",
        }}
      >
        <Svg
          height={radius * 2}
          width={radius * 2}
          viewBox={`0 0 ${halfCircle * 2} ${halfCircle * 2}`}
        >
          <Defs>
            <LinearGradient
              id="prefix__a"
              gradientUnits="userSpaceOnUse"
              x1={88}
              y1={0}
              x2={88}
              y2={176}
            >
              <Stop offset={0} stopColor={disabled ? "#e5e5e5" : "#FFCD4D"} />
              <Stop offset={1} stopColor={disabled ? "#e5e5e5" : "#E67A17"} />
            </LinearGradient>
          </Defs>
          <G rotation="-90" origin={`${halfCircle}, ${halfCircle}`}>
            <Circle
              cx="50%"
              cy="50%"
              strokeWidth={strokeWidth}
              stroke="#E5E5E5"
              r={radius}
              fill="transparent"
              strokeOpacity={0.5}
            />
            <AnimatedCircle
              ref={circleRef}
              cx="50%"
              cy="50%"
              strokeWidth={strokeWidth}
              stroke="url(#prefix__a)"
              r={radius}
              fill="transparent"
              strokeDasharray={circumference}
              strokeDashoffset={circumference}
              strokeLinecap="butt"
            />
          </G>
        </Svg>

        <View
          style={{
            width,
            height: width,
            justifyContent: "center",
            position: "absolute",
            alignItems: "center",
          }}
        >
          <Text
            style={{
              color: disabled ? "#B3B3B3" : "black",
              textAlign: "center",
              width: "60%",
              fontFamily: "NotoSansDevanagari-Bold",
              fontSize: 20,
            }}
          >
            {title}
          </Text>
          <Text
            style={{
              fontSize: 12,
              textAlign: "center",
              color: disabled ? "#B3B3B3" : "rgba(0,0,0,0.56)",
              fontFamily: "NotoSansDevanagari-Regular",
              width: "60%",
            }}
          >
            {subTitle}
          </Text>
        </View>
      </View>
    </>
  ) : null;
};

export default Stat;
